<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Simpan History</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" aria-label="Close" aria-label="Close" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid" style="padding: 2%">
      <div style="margin: 2%">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link active" role="tab" data-bs-toggle="tab" href="#tabHistory"> <i class="fas fa-history"></i> History </a>
          </li>
          @if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && !sharedService.isFinance()) {
            <li class="nav-item">
              <a class="nav-link" role="tab" data-bs-toggle="tab" href="#tabAdd"> <i class="fas fa-piggy-bank"></i> Add Simpan </a>
            </li>
          }
          @if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && !sharedService.isFinance() && totalReserveAmount > 0) {
            <li class="nav-item">
              <a class="nav-link" role="tab" data-bs-toggle="tab" href="#tabExpense"> <i class="fas fa-envelope-open-text"></i> Return Simpan </a>
            </li>
          }
          @if (profileList.length > 1 && sharedService.isBranchAccountHandler() == true) {
            <li class="nav-item">
              <a class="nav-link" role="tab" data-bs-toggle="tab" href="#tabTransfer"> <i class="fas fa-exchange-alt"></i> Transfer Simpan </a>
            </li>
          }
        </ul>
        <div class="tab-content">
          <!--tabHistory-->
          <div class="tab-pane active" role="tabpanel" id="tabHistory">
            <!--Show Reserve group list-->
            @if (reserveGroupList !== undefined && reserveGroupList.length > 0) {
              @for (rg of reserveGroupList; track rg.ID) {
                <div class="my-1 p-2 bg-info-subtle rounded d-flex align-items-center flex-wrap gap-2">
                  @if ((sharedService.isBossAccount() || rg.RequestedBy === sharedService.getLoggedInUsername()) && rg.Accepted === 0) {
                    <button class="btn btn-danger me-1" (click)="openDeleteReserveGroupDialog(rg)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  }
                  <div class="flex-grow-1">
                    Simpan Group {{ rg.ID }} - <b>({{ rg.Accepted }}/{{ rg.Total }} accepted)</b>
                  </div>
                  <button class="btn btn-info ms-auto" (click)="openReserveGroupDetailsModal(rg.ID)">View Details</button>
                </div>
              }
            }

            <table class="table table-hover">
              <thead>
                <tr>
                  @if (this.sharedService.isAdmin() == true || sharedService.isBossAccount() == true) {
                    <th></th>
                  }
                  <th>Date</th>
                  <th>Remark</th>
                  <th>Amount</th>
                  <!-- <th>Type</th> -->
                  <!-- <th>Closing Balance</th> -->
                  <th>HandleBy</th>
                </tr>
              </thead>
              <tbody>
                @for (reserve of reserveList; track reserve.ID) {
                  <tr>
                    @if (sharedService.isRoles([enums.BOSS, enums.ADMIN])) {
                      <td>
                        <button class="btn btn-danger" (click)="confirmDeleteTranscation(reserve)">
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    }
                    <td>{{ reserve.Date | date: "dd-MM-yyyy" }}</td>
                    <td>
                      {{ reserve.Remark }}
                      @if (reserve.SetId != undefined) {
                        <span class="text-info" role="button" (click)="openSetDialog(reserve.SetId)"><i class="fas fa-file-invoice-dollar"></i></span>
                      }
                    </td>
                    <td [ngClass]="checkAmountInOut(reserve.Amount)">{{ reserve.Amount }}</td>
                    <!-- <td>{{reserve.Type}}</td> -->
                    <!-- <td>{{transaction.ClosingBalance}}</td> -->
                    <td>{{ reserve.HandleBy }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <tr>
                  @if (sharedService.isRoles([enums.BOSS, enums.ADMIN])) {
                    <td></td>
                  }
                  <td></td>
                  <td><strong>Total:</strong></td>
                  <td>
                    <strong>{{ calculateTotalReserve(reserveList) | number: "1.2-2" }}</strong>
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <!--tabAddSimpan-->
          @if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false) {
            <div class="tab-pane" role="tabpanel" id="tabAdd">
              @if (sharedProfileId == undefined) {
                <app-add-simpan [selectedProfileID]="selectedProfileID" [selectedProfile]="selectedProfile" [selectedCustomer]="viewCustomer"></app-add-simpan>
              } @else {
                <app-add-reserve-group [sharedProfileId]="sharedProfileId" [selectedProfile]="selectedProfile" [selectedCustomer]="viewCustomer" [isModal]="false"></app-add-reserve-group>
              }
            </div>
          }
          <!--tabExpenseSimpan-->
          @if (sharedService.isAdmin() == false && sharedService.isBossAccount() == false && totalReserveAmount > 0) {
            <div class="tab-pane" role="tabpanel" id="tabExpense">
              <app-expense-simpan [selectedProfileID]="selectedProfileID" [profileList]="profileList" [selectedProfile]="selectedProfile" [viewCustomer]="viewCustomer" [totalReserveAmount]="totalReserveAmount"> </app-expense-simpan>
            </div>
          }
          <!--tabTransfer-->
          @if (profileList.length > 1) {
            <div class="tab-pane" role="tabpanel" id="tabTransfer">
              <app-transfer-simpan [profileList]="profileList" [selectedProfileID]="selectedProfileID"> </app-transfer-simpan>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
